import { createSelector } from '../../shared';
import type { AppState, ClickedHubPersonaState } from '..';

export const isInEVNavigationMode = createSelector<AppState, ClickedHubPersonaState, boolean>(
    'isInEVNavigationMode',
    [(appState: AppState) => appState.view.navigationState.clickedHubPersona],
    clickedHubPersona => {
        return clickedHubPersona && clickedHubPersona.origin === 'PersonaExpandedView';
    }
);
